import React from 'react';
import styled from "styled-components";

const HayaatVideoSection = () => {

    const content1 = 'در چند قدمی حرم امام رضا (ع)، مالک آپارتمان مبله اما با امکانات اقامت در سطح یک هتل شوید. همچنین با وجود حراست و خانه‌داری هتل، در زمان عدم حضور شما در مشهد، دغدغه‌ای برای امنیت آپارتمان خود و نگهداری از آن نخواهید داشت. ';
    const content2 = 'یکی از مزیت‌های این واحدها امکان کسب درآمد از آنهاست. شما می‌توانید در زمان‌هایی که در مشهد حضور ندارید، از هتل بخواهید که واحدتان را اجاره بدهد و ماهانه مبالغ اجاره را از طرف هتل دریافت کنید.';

    return (
        <div className="container z-index10">
            <div className="row align-items-center">
                <div className="col-12 col-lg-5">
                    <div className="d-flex flex-column justify-content-end position-relative aparat-video-title">
                        <h2 className="h1-bold mb-16 mb-lg-24 d-block d-lg-none">آپارتمان مبله در 300 متری از حرم امام رضا(ع)</h2>
                        <h2 className="h1-bold mb-16 mb-lg-24 d-none d-lg-block">آپارتمان مبله در 300 متری حرم مطهر</h2>

                        <p className="h3-normal">{content1}</p>

                        <p className="h3-normal mt-24 d-none d-lg-block">{content2}</p>
                    </div>
                </div>

                <div className="col-lg-1"/>

                <div className="col-12 col-lg-6">
                    <div className="position-relative aparat-video mt-56 mt-lg-0">
                        <AparatVideoWrapper>
                            <div className="h_iframe-aparat_embed_frame"><span style={{display: 'block', paddingTop: '66%'}}></span>
                                <iframe src="https://www.aparat.com/video/video/embed/videohash/hdHUb/vt/frame" title="مرکز تجاری، اقامتی حیات و ایمان" allowFullScreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"></iframe>
                            </div>
                        </AparatVideoWrapper>
                    </div>

                    <p className="h3-normal mt-56 mt-lg-0 d-block d-lg-none">{content2}</p>
                </div>
            </div>
        </div>
    );
};

export default React.memo(HayaatVideoSection);

// styles


const AparatVideoWrapper = styled.div`
	z-index: 1;
	position: relative;
	
	.h_iframe-aparat_embed_frame {
		position:relative;
	}
	
	.h_iframe-aparat_embed_frame .ratio {
		display:block;
		width:100%;
		height:auto;
	}
	
	.h_iframe-aparat_embed_frame iframe {
		position:absolute;
		top:0;
		left:0;
		width:100%;
		height:100%;
		border: 0;
		border-radius: 8px;
	}

	@media (max-width: ${props => props.theme.screenSmMax}) {
		left: unset;
		top: unset;
	}
`;
